import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { Prescription, PrescriptionFilter, PrescriptionOut, Regions } from "../models/PrescriptionsModel";

export default class PrescriptionsApi {
    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
    }

    async getPrescriptions(filter: PrescriptionFilter | null,  paging: PagingParams): Promise<PagedResults<Prescription>> {
        const res = await this.http.get(`${this.rootPath}/api/v1/exemptions/list`, {
            params: {
                count: paging.count,
                offset: paging.offset,
                reg_id: filter?.reg_id ? filter.reg_id : undefined,
                activity_type: filter?.activity_type ? filter.activity_type : undefined,
                valid_from: filter?.valid_from ? new Date(filter.valid_from).getTime() : undefined,
                valid_to: filter?.valid_to ? new Date(filter.valid_to).getTime() : undefined
            }
        });
        return res.data;
    }

    async getPrescriptionsTypes(): Promise<string[]> {
        /*
            ALL TYPES:
            SEEDING,
            TREATMENT,
            FERTILIZATION,
            HARVESTING,
            IRRIGATION,
            GENERIC,
            UNKNOWN
        */
        return ["TREATMENT","GENERIC"];
    }

    async getRegions(paging: PagingParams, filter: string | null): Promise<PagedResults<Regions>> {
        const res = await this.http.get(`${this.rootPath}/api_basic/v1/plots/dictionary_regions`, {
            params: {
                count: 100,
                filter: filter ? `^region_label like ${filter.toUpperCase()}` : undefined,
                has_competence: true
            }
        });
        return res.data;
    }

    async getRegionsList(): Promise<Regions[]> {
        const res = await this.http.get(`${this.rootPath}/api_basic/v1/plots/dictionary_regions`, {
            params: {
                count: 100,
                has_competence: true
            }
        });
        return res.data.records;
    }

    async savePrescription(prescription: PrescriptionOut): Promise<Prescription> {
        const res = await this.http.post(`${this.rootPath}/api/v1/exemptions`, prescription);
        return res.data;
    }

    async editPrescription(prescription: PrescriptionOut, id: number): Promise<Prescription> {
        const res = await this.http.put(`${this.rootPath}/api/v1/exemptions/${id}`, prescription);
        return res.data;
    }

    async deletePrescription(id: number): Promise<Prescription> {
        const res = await this.http.delete(`${this.rootPath}/api/v1/exemptions/${id}`);
        return res.data;
    }

}
